import { ethers } from "ethers";
import { EVM_CONFIG, BASE_SEPOLIA_TOKENS, type TokenInfo } from "../../config";
import { requestSupportedTokens } from "../../utils/relayer-client";
import { privateTokenPool } from "../../joinsplit-v2/privatePools";
import { resolveTokenInfo } from "./tokenCatalog";

let cached: { expires: number; value: Promise<string[]> } | undefined;
export function supportedTokenAddresses(force = false): Promise<string[]> {
  if (!privateTokenPool())
    return Promise.resolve(
      BASE_SEPOLIA_TOKENS.filter((t) => !t.isNative).map((t) => t.address),
    );
  if (!force && cached && cached.expires > Date.now()) return cached.value;
  const value = requestSupportedTokens().then((result) => {
    if (
      result.success !== true ||
      result.chainId !== EVM_CONFIG.CHAIN_ID ||
      !Array.isArray(result.addresses) ||
      result.addresses.length > 200 ||
      result.addresses.some(
        (a: unknown) =>
          typeof a !== "string" ||
          !ethers.isAddress(a) ||
          a === ethers.ZeroAddress,
      )
    )
      throw Error("Supported tokens could not be loaded.");
    return [
      ...new Set<string>(
        result.addresses.map((a: string) => ethers.getAddress(a)),
      ),
    ];
  });
  cached = { expires: Date.now() + 15000, value };
  void value.catch(() => {
    if (cached?.value === value) cached = undefined;
  });
  return value;
}

export async function resolveSupportedToken(
  address: string,
): Promise<TokenInfo> {
  const canonical = ethers.getAddress(address);
  if (
    canonical !== ethers.ZeroAddress &&
    !(await supportedTokenAddresses()).includes(canonical)
  )
    throw Error("This token is not supported by this app.");
  return resolveTokenInfo(canonical);
}
